<template>
  <div class="echart-content">
    <div :id="echartId" style="width:100%;height:100%">123123</div>
  </div>
</template>

<script>
import uuidv1 from "uuid/v1";
export default {
  props: {
    chartData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      echartId: uuidv1(),
    };
  },
  created() {
    console.log(this.chartData);
  },
  mounted() {
    this.getData();
    // this.getEchart(obj);
  },
  methods: {
    getData() {
      let data = JSON.parse(JSON.stringify(this.chartData));

      let obj = {};
      let dataseries = [];

      if (data.subtitle == undefined) {
        obj.legendtitle = [data.title];

        let icon = ["diamond", "rect", "triangle"];

        if (typeof data.y[0] != "string") {
          console.log("111");
          for (let i = 0; i < data.y.length; i++) {
            dataseries.push({
              name: data.title[i],
              data: data.y[i],
              type: "line",
              symbol: icon[i],
              // legend: icon[i]
            });
          }
        } else {
          console.log("222");
          dataseries = [
            {
              name: data.title,
              data: data.y,
              type: "line",
            },
          ];
        }
      } else {
        if (data.subtitle instanceof Array) {
          obj.legendtitle = data.subtitle;
        } else {
          obj.legendtitle = [data.subtitle];
        }
        // let dataseries = [];
        let icon = ["diamond", "rect", "triangle"];
        console.log(typeof data.y[0]);
        if (typeof data.y[0] != "string") {
          console.log("111");
          for (let i = 0; i < data.y.length; i++) {
            dataseries.push({
              name: data.subtitle[i],
              data: data.y[i],
              type: "line",
              symbol: icon[i],
              // legend: icon[i]
            });
          }
        } else {
          console.log("222");
          dataseries = [
            {
              name: data.subtitle,
              data: data.y,
              type: "line",
            },
          ];
        }
      }

      obj.xdata = data.x;
      obj.dataseries = dataseries;
      obj.unit = data.unit;
      console.log(obj);
      this.getEchart(obj);
    },
    getEchart(obj) {
      console.log(obj);
      let this_ = this;
      let myChart = this.$echarts.init(document.getElementById(this.echartId));
      var option = {
        title: {
          text: obj.title,
          left: "center",
        },
        grid: {
          x: 60,
          y: 50,
          x2: 50,
          y2: 60,
          borderWidth: 10,
          width: "70%",
        },
        color: [
          "#d2b533",
          "#fe3c00",
          "#7928cb",
          "#8eb2f0",
          "#003690",
          "#0db198",
          "#9ff093",
        ],
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: obj.legendtitle,
          top: "20%",
          right: "3%",
          orient: "vertical", //垂直显示
          // icon: ["line", "pin", "diamond"]
        },
        calculable: true,
        xAxis: [
          {
            type: "category",
            data: obj.xdata,
            name: "日期",
          },
        ],
        yAxis: [
          {
            type: "value",
            name: obj.unit,
          },
        ],
        series: obj.dataseries,
      };

      myChart.setOption(option, true);
      if (myChart) {
        window.addEventListener("resize", function() {
          myChart.resize();
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.echart-content {
  width: 100%;
  height: 300px;
}
</style>
